import { forwardRef } from 'react';

import { SpacerElement } from './styles';
import { SpacerProps } from './types';

/**
 * Spacer component
 * A component that adds space between elements.
 */
const Spacer = forwardRef<HTMLSpanElement, SpacerProps>(
  ({ width, height, id }, ref) => {
    return <SpacerElement ref={ref} height={height} id={id} width={width} />;
  }
);

Spacer.displayName = 'Spacer';

export default Spacer;
